export function getBrandSpecificNotThePolicyHolderBody1(brandConfig) {
  switch (brandConfig.brandName) {
    case 'nibnz':
      return `As a member listed on a policy, you can have your own access to log in, view your cover and usage, change your contact details as well as submit pre-approvals and claims.`;
    default:
      return `As a member listed on a policy, you can have your own access to log in and manage your cover.`;
  }
}

export function getBrandSpecificNotThePolicyHolderBody2(brandConfig) {
  switch (brandConfig.brandName) {
    case 'cignagu':
      return `To log in for the first time you need to use the email address associated with the membership i.e. the policyholder’s email. The verification code will be sent to that email address so please ensure you have access to it before submitting as the code will expire after 15 minutes.`;
    case 'gu':
      return `To log in, you’ll need to enter the individual email address that’s registered to you as a policy member. If you're not the policyholder and your individual email address hasn’t been assigned to you, ask the policyholder to add it for you in their member account.`;
    case 'nibnz':
      return `To log in, you’ll need to enter the individual email address that is registered to you. If you're not the policyholder and your individual email address hasn’t been assigned to you, ask the policyholder to add it for you in their own my nib member account.`;
    default:
      return `To log in, you’ll need to enter the individual email address or phone number that’s registered to you as a policy member. If you're not the policyholder and your individual email address or phone number hasn’t been assigned to you, ask the policyholder to add it for you in their member account.`;
  }
}
